module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_vm._m(0), _vm._v(" "), _c('cms-content', {
    staticClass: "content js-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask mask--page-title"
  }, [_c('h1', {
    staticClass: "page-title js-page-title"
  }, [_vm._v("à propos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43e2a274","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AboutView.vue
// module id = 172
// module chunks = 1